import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/common/ProtectedRoute';

// 사용자 페이지 컴포넌트 import (Lazy loading)
const Main = React.lazy(() => import('./pages/Main/Main'));
const About = React.lazy(() => import('./pages/About/About'));
const DoctorList = React.lazy(() => import('./pages/Doctors/DoctorList'));
const DoctorDetail = React.lazy(() => import('./pages/Doctors/DoctorDetail'));
const TreatmentList = React.lazy(() => import('./pages/Treatment/TreatmentList'));
const TreatmentDetail = React.lazy(() => import('./pages/Treatment/TreatmentDetail'));
const NoticeList = React.lazy(() => import('./pages/Notice/NoticeList'));
const NoticeDetail = React.lazy(() => import('./pages/Notice/NoticeDetail'));
const Info = React.lazy(() => import('./pages/Info/Info'));
const Contact = React.lazy(() => import('./pages/Contact/Contact'));

// Admin 페이지 컴포넌트 import (Lazy loading)
const AdminLogin = React.lazy(() => import('./pages/Admin/Login'));
const AdminDashboard = React.lazy(() => import('./pages/Admin/Dashboard'));
const DoctorManagement = React.lazy(() => import('./pages/Admin/DoctorManagement'));
const TreatmentManagement = React.lazy(() => import('./pages/Admin/TreatmentManagement'));
const NoticeManagement = React.lazy(() => import('./pages/Admin/NoticeManagement'));
const ConsultationManagement = React.lazy(() => import('./pages/Admin/ConsultationManagement'));

function App() {
  return (
    <Router>
      <React.Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
        <Routes>
          {/* 사용자 페이지 */}
          <Route path="/" element={<MainLayout><Main /></MainLayout>} />
          <Route path="/about" element={<MainLayout><About /></MainLayout>} />
          <Route path="/doctors" element={<MainLayout><DoctorList /></MainLayout>} />
          <Route path="/doctors/:id" element={<MainLayout><DoctorDetail /></MainLayout>} />
          <Route path="/treatment" element={<MainLayout><TreatmentList /></MainLayout>} />
          <Route path="/treatment/:id" element={<MainLayout><TreatmentDetail /></MainLayout>} />
          <Route path="/notice" element={<MainLayout><NoticeList /></MainLayout>} />
          <Route path="/notice/:id" element={<MainLayout><NoticeDetail /></MainLayout>} />
          <Route path="/info" element={<MainLayout><Info /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />

          {/* Admin 페이지 */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/doctors"
            element={
              <ProtectedRoute>
                <DoctorManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/treatments"
            element={
              <ProtectedRoute>
                <TreatmentManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/notices"
            element={
              <ProtectedRoute>
                <NoticeManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/consultations"
            element={
              <ProtectedRoute>
                <ConsultationManagement />
              </ProtectedRoute>
            }
          />

          {/* 404 페이지 */}
          <Route path="*" element={<MainLayout><div className="flex items-center justify-center min-h-[60vh]"><div className="text-center"><h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1><p className="text-gray-600">페이지를 찾을 수 없습니다.</p></div></div></MainLayout>} />
        </Routes>
      </React.Suspense>
    </Router>
  );
}

export default App;
